import * as yup from "yup";

// Reusable select option schema
const selectOptionSchema = yup.object({
  id: yup.string().required(),
  name: yup.string().optional(),
});

// Restriction type options (only for GLOBAL scope)
export const PROMO_RESTRICTION_TYPES = [
  { value: "", label: "Tous les types (événements, offres, Établissements)" },
  { value: "EVENT", label: "Événement only" },
  { value: "SPECIALS", label: "Offres only" },
  { value: "PLACE", label: "Établissements only" },
] as const;

export const PROMO_RESTRICTION_TYPESV2 = [
  { value: "NONE", label: "All types (events, offers, places)" },
  { value: "EVENT", label: "Events only" },
  { value: "SPECIALS", label: "Offers only" },
  { value: "PLACE", label: "Établissements only" },
] as const;

export const createPromoCodeSchema = yup
  .object({
    name: yup.string().required("Ce champ est obligatoire"),

    // Scope is required and must be one of the valid values
    scope: yup
      .string()
      .oneOf(["EVENT", "SPECIALS", "PLACE", "GLOBAL"])
      .required("Ce champ est obligatoire"),

    // Restriction type: only used when scope === GLOBAL
    restrictionType: yup
      .string()
      .oneOf(["", "EVENT", "SPECIALS", "PLACE"])
      .nullable()
      .optional(),

    // Entity selectors (nullable, validated conditionally below)
    event: selectOptionSchema.nullable(),
    offer: selectOptionSchema.nullable(),
    place: selectOptionSchema.nullable(),

    discount: yup
      .number()
      .positive("La réduction doit être positive")
      .required("Ce champ est obligatoire")
      .typeError("Ce champ est obligatoire"),

    maxUses: yup
      .number()
      .positive("L'utilisation max doit être positive")
      .required("Ce champ est obligatoire")
      .typeError("Ce champ est obligatoire"),

    isActive: yup.boolean().default(true),
    description: yup.string().nullable(),

    // Service items (for EVENT scope with specific services)
    items: yup.array().of(
      yup.object({
        serviceId: yup.string().required(),
        maxUses: yup.number().positive().required(),
      }),
    ),
  })
  .test("scope-validation", "Configuration invalide", function (values) {
    const { scope, event, offer, place } = values;

    // ✅ Case 1 & 2: GLOBAL scope → no entity required
    if (scope === "GLOBAL") {
      // restrictionType can be empty (truly global) or set (type-restricted)
      return true;
    }

    // ✅ Case 3: Linked scope → specific entity required
    if (scope === "EVENT" && !event) {
      return this.createError({ path: "event", message: "Event requis" });
    }
    if (scope === "SPECIALS" && !offer) {
      return this.createError({ path: "offer", message: "Offer requis" });
    }
    if (scope === "PLACE" && !place) {
      return this.createError({ path: "place", message: "Place requis" });
    }

    return true;
  });

export type createPromoDto = yup.InferType<typeof createPromoCodeSchema>;
